/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const saveSocialClipSelectionDataSchema = z.object({
  saved: z.boolean(),
});

export interface ISaveSocialClipSelectionV1Data {
  saved: boolean;
}

export const saveSocialClipSelectionV1ResponseSchema = createApiResponseSchema(
  saveSocialClipSelectionDataSchema,
) as z.ZodSchema<IAPI<ISaveSocialClipSelectionV1Data>>;

export type ISaveSocialClipSelectionV1Response = IAPI<ISaveSocialClipSelectionV1Data>;
